module.exports = __webpack_public_path__ + "static/media/added.7dc2435f.svg";